import React, { Component } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import './LiveMintDetails.css';

class LiveMintDetails extends Component {
  constructor(props) {
    super(props);
    this.buyBondingCurveItem = this.buyBondingCurveItem.bind(this);
    this.sellBondingCurveItem = this.sellBondingCurveItem.bind(this);

    this.state = {};
  }

  async sellBondingCurveItem() {
    if (window.ethereum == null) {
      window.open("https://metamask.app.link/dapp/" + window.location.host + window.location.pathname + window.location.search);
      return;
    }
    if(this.props.account != null) {
      this.props.setTransactionStatus("Pending");
      let didApprove = await encryptUtils.sellBondingCurveItem(this.props.account.address, this.props.item, this.props.item.protocol);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
          'streamer_profile',
          'streamer_profile_sell_bonding_curve_nft',
          'info',
          "https://the402.xyz",
          {
            item: this.props.item
          },
        );
      } else {
        this.props.setTransactionStatus("None");
      }
    }
  }

  async buyBondingCurveItem() {
    if (window.ethereum == null) {
      window.open("https://metamask.app.link/dapp/" + window.location.host + window.location.pathname + window.location.search);
      return;
    }
    if(this.state.ethBalance < this.props.item.mintPrice) {
      alert(
        "You do not have enough funds in your wallet to purchase an edition"
      );
      return;
    }
    if(this.props.account != null) {
      this.props.setTransactionStatus("Pending");
      let didApprove = await encryptUtils.buyBondingCurveItem(this.props.account.address, this.props.item, this.props.item.protocol);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
          'streamer_profile',
          'streamer_profile_mint_bonding_curve_nft',
          'info',
          "https://the402.xyz",
          {
            item: this.props.item
          },
        );
      } else {
        this.props.setTransactionStatus("None");
      }
    }
  }

  render() {
    return (
      <div className="liveMintDetailsContainer">
        <div className="flex mt-4 ml-4 w-full">
          <div className="mr-4 mt-2 text-xs font-semibold h-10 items-center flex-col flex text-teal-400">
            LIVE:
          </div>
          <div className="flex">
            <div className="w-8 flex flex-col items-center">
              <div className="text-md text-white font-semibold">
                {this.props.liveNFTDaysLeft}
              </div>
              <div className="text-black dark:text-zinc-400 text-zinc-400 font-medium text-xs flex">
                DAY
              </div>
            </div>
            <div className="flex flex-col">
              <div className="text-md text-white font-semibold">
                :
              </div>
            </div>
            <div className="flex flex-col items-center w-8">
              <div className="text-md text-white font-semibold">
                {this.props.liveNFTHoursLeft}
              </div>
              <div className="text-black dark:text-zinc-400 text-zinc-400 font-medium text-xs flex">
                HR
              </div>
            </div>
            <div className="flex flex-col h-10">
              <div className="text-md text-white font-semibold">
                :
              </div>
            </div>
            <div className="flex flex-col items-center w-8">
              <div className="text-md text-white font-semibold">
                {this.props.liveNFTMinutesLeft}
              </div>
              <div className="text-black dark:text-zinc-400 text-zinc-400 font-medium text-xs flex">
                MIN
              </div>
            </div>
            <div className="flex flex-col h-10">
              <div className="text-md text-white font-semibold">
                :
              </div>
            </div>
            <div className="flex flex-col items-center w-8">
              <div className="text-md text-white font-semibold">
                {this.props.liveNFTSecondsLeft}
              </div>
              <div className="text-black dark:text-zinc-400 text-zinc-400 font-medium text-xs flex">
                SEC
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center">
          <div className="text-lg sm:text-xl w-11/12 font-semibold text-white">
            {this.props.liveNFTName}
          </div>
        </div>
        <div className="flex justify-around mt-1">
          <div className="flex flex-col">
            <div
              onClick={this.buyBondingCurveItem}
              className="hover:-translate-y-0 hover:scale-105 duration-500 hover:bg-zinc-300 ml-2 mx-auto bg-gray-200 h-12 w-32 font-semibold justify-center items-center rounded-lg flex font-medium text-black cursor-pointer"
            >
              Buy
            </div>
            <div className="flex flex-col items-center justify-center">
              <div className="text-md text-white font-bold">
                {this.props.liveNFTBuyPrice/1000000000000000000} ETH
              </div>
              <div className="invisible md:visible text-sm text-gray-500">
                {this.props.liveNFTBuyCreatorFee}% creator fee
              </div>
              <div className="invisible md:visible flex text-sm text-gray-500">
                {this.props.liveNFTBuyPriceTotal/1000000000000000000} ETH
              </div>
            </div>
          </div>
          {
            this.props.item != null && !this.props.item.isNonLiquid
              ?
            <div className="flex flex-col">
              <div
                onClick={this.sellBondingCurveItem}
                className="hover:-translate-y-0 hover:scale-105 duration-500 hover:bg-zinc-700 mr-2 mx-auto bg-zinc-800 h-12 w-32 font-semibold justify-center items-center rounded-lg flex font-medium text-gray-300 cursor-pointer"
              >
                Sell
              </div>
              <div className="flex flex-col items-center justify-center">
                <div className="text-md text-white font-bold">
                  {this.props.liveNFTSellPrice} ETH
                </div>
                <div className="text-sm text-gray-500">
                  {this.props.liveNFTSellCreatorFee}% creator fee
                </div>
                <div className="flex text-sm text-gray-500">
                  {this.props.liveNFTSellPriceTotal} ETH
                </div>
              </div>
            </div>
              :
            null
          }
        </div>
      </div>
    );
  }
}

export default LiveMintDetails;
